// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clientPoolDialogIsShow_Back_Discard-margin[data-v-36b7100c]{margin:5px 0}", ""]);
// Exports
module.exports = exports;
